import styled from "styled-components";

export const StyledPromoTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledPromoTypeItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #e9edf5;
  background: #fff;
  height: 60px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8faff;

    .promo-title,
    .promo-desc {
      color: #2060ea;
    }

    svg path {
      stroke: #2060ea;
    }
  }
`;

export const StyledPromoTextContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledPromoTitle = styled.span`
  color: #000;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  transition: color 0.2s ease-in-out;
`;

export const StyledPromoDescription = styled.span`
  color: #000;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
  transition: color 0.2s ease-in-out;
`;
